import React from 'react';
import ReminderDropDown from './ReminderDropDown';
import MessageDropDown from './MessageDropDown';
import NotificationDropDown from './NotificationDropDown';
import Hidden from 'src/scenes/components/Hidden';
import SearchDropDown from './SearchDropDown';
import { createUseStyles } from 'src/theming';

const useStyles = createUseStyles((theme) => ({
  action: {
    marginRight: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      marginRight: '2rem',
    },
  },
}));

const NavActions = ({ navigateTo }) => {
  const classes = useStyles();

  return (
    <>
      <Hidden smUp>
        <SearchDropDown className={classes.action} />
      </Hidden>

      <MessageDropDown className={classes.action} navigateTo={navigateTo} />
      <NotificationDropDown className={classes.action} navigateTo={navigateTo} />
      <ReminderDropDown className={classes.action} navigateTo={navigateTo} />
    </>
  );
};

export default NavActions;
